import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { priceFormat } from 'newFunctions/sanitizeData'
import { dateFormatComplete } from 'newFunctions/dateFormat'
import Styles from './styles.module.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { decodeStorage, encodeStorage } from 'functions/storageBase64';
import { dataLayerButtons } from 'functions/dataLayerFunction';
import { removeStorage } from 'newFunctions/storageBase64';

const ModulePagos = (props) => {
    const { data } = props;
    const {
        payment_not_generate_interest = 0,
        payday_limit = 0
    } = data || {};
    const history = useHistory();

    const [ PagoNoInteres, setPagoNoInteres] = useState(payment_not_generate_interest);
    const [ FechaLimite, setFechaLimite ] = useState(payday_limit);

    const handleTarjetaCredito = () => {
        removeStorage('pagoExpress')
        removeStorage('cardendingPayment')
        removeStorage('noInternetPayment')

        const cardending = decodeStorage('cardending')
        encodeStorage('cardendingPayment', cardending)
        dataLayerButtons({eventName: "credito_pagar"})
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    };

    const handlePayment = () => {
        handleTarjetaCredito()
    }

    useEffect(() => {
        if(data){
            setPagoNoInteres(data?.payment_not_generate_interest)
            setFechaLimite(data?.payday_limit)
        }
    },[data]) 

    return(
         <div className={`${Styles?.contSectionPagos} ${Styles?.cardStyle}`}>
            <div className={Styles?.titleCard}>Próximo pago</div>
            <div className={Styles?.contImports}>
                <dl>
                    <dt>Cantidad:</dt>
                    <dd>${ priceFormat(PagoNoInteres) } MXN</dd>
                </dl>
                <dl>
                    <dt>Fecha límite:</dt>
                    <dd>{dateFormatComplete(FechaLimite)}</dd>
                </dl>
            </div>
            <div className={Styles?.handleClick} onClick={handlePayment}>Pagar mi tarjeta</div>
        </div>
    )
}
export default ModulePagos;